import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface StoneLookupState {
  item: any | null;
  steps: any[];
  loading: boolean;
  error: string | null;
}

const initialState: StoneLookupState = {
  item: null,
  steps: [],
  loading: false,
  error: null,
};

const stoneLookupSlice = createSlice({
  name: 'stone.stoneLookup',
  initialState,
  reducers: {
    searchStoneByIdRequest: (state, _action: PayloadAction<string | number>) => {
      state.loading = true;
      state.item = null;
      state.steps = [];
      state.error = null;
    },
    searchStoneByIdSuccess: (state, action: PayloadAction<{ item: any; steps: any[] }>) => {
      state.item = action.payload.item;
      state.steps = action.payload.steps;
      state.loading = false;
    },
    searchStoneByIdFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    clearStoneLookup: (state) => {
      state.item = null;
      state.steps = [];
    },
  },
});

export const { searchStoneByIdRequest, searchStoneByIdSuccess, searchStoneByIdFailure, clearStoneLookup } = stoneLookupSlice.actions;
export default stoneLookupSlice.reducer;
